export default "/images/deliver1.png?45cb41955765325fcb841424b48d7fef";